export default "__VITE_ASSET__CbTOZCNx__"